import type { ReactNode } from 'react';

import type { MissionFormTab } from '../enums/tab.enum';

// The wizard steps and children of the given tabs, in their order.
export const pickSteps = <
  D extends Readonly<{ step: unknown; child: ReactNode }>,
>(
  definitions: Readonly<Record<MissionFormTab, D>>,
  tabs: readonly MissionFormTab[],
) => ({
  steps: tabs.map((tab) => definitions[tab].step as D['step']),
  wizardChildren: tabs.map((tab) => definitions[tab].child),
});
